export const METRIC_ORIGIN_KEY = "metric-origin";
export const CHANNEL_KEY = "channel";